import type { ReactNode } from 'react';

export const symbol_mobile_arrow_down: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v437q0 24.75-17.62 42.37Q722.75-40 698-40H260Zm0-60h438v-760H260v760Zm0 0v-760 760Zm231-232q5-2 10-7l113-113q9-9 9-21.5t-9-21.5q-9-9-21.5-9t-21.5 9l-61 61v-164q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v164l-61-61q-9-9-21-8.5t-21 9.5q-9 9-9 21.5t9 21.5l112 112q5 5 10.13 7 5.14 2 11 2 5.87 0 10.87-2Z"
		/>
	</svg>
);
